export default __webpack_public_path__ + "static/media/logo.093e1534.png";